import { Pipe, PipeTransform } from "@angular/core";
import { Message, RequestType, ResponseStatus } from "@handshake/core-types";

const DEFAULT_CURRENCY = "SGD";

@Pipe({
  name: "combineMessage",
  standalone: true,
})
export class CombineMessagePipe implements PipeTransform {
  transform(message: Message): string {
    if (message.text) {
      return message.text;
    } else if (message.responseId && !message.requestId) {
      switch (message.response?.status) {
        case ResponseStatus.ACCEPTED:
          return "Accepted";
        case ResponseStatus.REJECTED:
          return "Rejected";
        default:
          return "";
      }
    } else if (message.requestId) {
      switch (message.request.requestType) {
        case RequestType.MILESTONE_COMPLETED:
          return "Request Milestone Approval: Milestone " + message?.milestone?.name;
        case RequestType.DELAY:
          return "Request Milestone Delayed: Milestone " + message?.milestone?.name;
        case RequestType.DRAWDOWN:
          return (
            "Request Drawdown: " +
            (message?.request?.metadata?.amount
              ? new Intl.NumberFormat("en-SG", {
                  style: "currency",
                  currency: message?.milestone?.project?.currency || DEFAULT_CURRENCY,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(message.request.metadata.amount)
              : "")
          );
        default:
          return "";
      }
    } else {
      return "";
    }
  }
}
